// extracted by mini-css-extract-plugin
module.exports = {"stakeSelector":"_2Qa904Z","caption":"_34vaeCM","gameIcon":"_1FC3Z4T"};